import React, { useState, useEffect, useMemo } from 'react';
import { Container, Row, Col, Button, Image } from 'react-bootstrap';
import Menu from '../sections/Menu';
import Footer from '../sections/Footer';
import Partners from '../sections/Partners';
import FAQ from '../sections/FAQ';
import Analytics from '../sections/Analytics';
import Reviews from '../sections/Reviews';
import FunctionalityAgency from '../sections/FunctionalityAgency';
import CTA from '../sections/CTA';
import heroImage from '../images/hero.png';
import { AnalyticsHandle } from '../components/AnalyticsHandle';
import PageMeta from '../seo/PageMeta';
import { buildFaqStructuredData, buildServiceStructuredData } from '../seo/structuredData';

function PracaTymczasowaOutsourcing() {
  const [content, setContent] = useState(null);
  const { logRegisterClick } = AnalyticsHandle();

  const handleRegisterClick = () => {
    logRegisterClick('temp_outsourcing_hero_primary');
    window.open('/register', '_self');
  };

  useEffect(() => {
    fetch("/data/content.json")
      .then((res) => res.json())
      .then((data) => setContent(data))
      .catch((error) => console.error("Error loading JSON:", error));
  }, []);

  const pageStructuredData = useMemo(
    () => [
      buildFaqStructuredData(content, "/praca-tymczasowa-i-outsourcing"),
      buildServiceStructuredData({
        path: "/praca-tymczasowa-i-outsourcing",
        name: "System RCP dla pracy tymczasowej i outsourcingu",
        description:
          "eGodziny dla agencji pracy tymczasowej i outsourcingu: ewidencja czasu pracy, kontrola obecności i raportowanie.",
        serviceType: "System RCP",
        audience: "Agencje pracy tymczasowej i firmy outsourcingowe",
      }),
    ].filter(Boolean),
    [content]
  );

  if (!content) return <div></div>;

  return (
    <>
      <PageMeta
        path="/praca-tymczasowa-i-outsourcing"
        structuredData={pageStructuredData}
      />
      <Menu />

      {/* Hero Section */}
      <Container className='hero align-content-center' style={{marginBottom: "120px"}}>
        <Row>
          <Col xs={12} md={6} className='text-md-start'>
            <Row className='py-3'>
              <h1 className='title_hero'>{content.hero.heading}</h1>
            </Row>

            <Row className='py-3 mb-5'>
              <p className='text_hero'>{content.hero.p1}</p>
            </Row>
            <Row className='d-md-none text-center py-3 mb-4'>
              <Col>
                <Image style={{width: '400px'}} fluid src={heroImage} alt="Aplikacja eGodziny" className="mobile-hero-image" />
              </Col>
            </Row>

            <Row className='py-3 test_buttons'>
              <Button className='button-default d-block mb-3' onClick={handleRegisterClick}>
                {content.hero.button1}
              </Button>

              <Button variant="outline-dark" className='outline mb-3' href="/praca-tymczasowa-i-outsourcing#functionality">
                {content.hero.button2}
              </Button>
            </Row>

            <div className="buttons-container-new">
              {[content.hero.button_info1, content.hero.button_info2, content.hero.button_info3, content.hero.button_info4, content.hero.button_info5, content.hero.button_info6].map((btn, i) => (
                <Button className="button-info" key={i}>
                  <span className="material-icons">{btn.icon}</span>
                  <span>{btn.text}</span>
                </Button>
              ))}
            </div>

          </Col>

          <Col xs={12} md={6} className='d-none d-md-block text-center'>
            <Image fluid src={heroImage} alt="Aplikacja eGodziny" />
          </Col>
        </Row>
      </Container>

      {/* Analytics Section */}
      <Analytics />

      {/* Reviews Section */}
      <div style={{ backgroundColor: '#ffffffff', paddingTop: '60px'}}>
        <Container className="py-1">
          <div className="text-center">
            <h2 style={{
              fontSize: '2.2rem',
              fontWeight: '700',
              color: '#1f2937',
              marginBottom: '16px'
            }}>
              Co mówią nasi klienci?
            </h2>
            <p style={{
              fontSize: '1.1rem',
              color: '#6b7280',
              maxWidth: '700px',
              margin: '0 auto'
            }}>
              Poznaj opinie firm, które zaufały eGodzinom
            </p>
          </div>
          <Reviews />
        </Container>
      </div>

      <div style={{height: "80px"}}></div>

      {/* Partners Section */}
      <Partners />

      <FunctionalityAgency />

      {/* FAQ Section */}
      <FAQ content={content} />

      {/* CTA Section */}
      <CTA />

      <Footer />
    </>
  );
}

export default PracaTymczasowaOutsourcing;
